import React from 'react';
import { useIntl } from 'react-intl';

import { StatesContent, StatesTitle, StatesWrapper } from './style';

type Props = {
  'data-test-id'?: string;
};

const Empty = (props: Props): JSX.Element => {
  const intl = useIntl();
  return (
    <StatesWrapper {...props}>
      <StatesTitle>{intl.formatMessage({ id: 'analytics.charts.empty.title' })}</StatesTitle>
      <StatesContent>
        {intl.formatMessage({ id: 'analytics.charts.empty.description' })}
      </StatesContent>
    </StatesWrapper>
  );
};

export default Empty;
